import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { ListTable } from 'gnos-tables'
import _ from 'lodash'

import CellStyleWrapper from '../../../../../../../../../../../../../../../components/TableCell/components/CellStyleWrapper'
import Entity from '../../../../../../../../../../../../../../../components/TableCell/components/Entity'
import Signals from '../../../../../../../../../../../../../../../components/TableCell/components/Signals'

import { LOCALE_PREFIX } from '../../../../../../constants'

import hocConnect from './hocConnect'
import './styles.scss'

@injectIntl
@hocConnect
export default class Publishers extends Component {
    static propTypes = {
        block: PropTypes.string,
        data: PropTypes.array,
        dataLocale: PropTypes.string,
        failed: PropTypes.bool,
        id: PropTypes.string,
        isLoading: PropTypes.bool,
        intl: PropTypes.object,
        level: PropTypes.string,
        loaded: PropTypes.bool,
        loadPublishersData: PropTypes.func.isRequired,
        locale: PropTypes.string,
        module: PropTypes.string,
        tenderId: PropTypes.number.isRequired,
    }

    componentDidMount() {
        const { loaded, dataLocale, locale, failed } = this.props

        if ((!loaded || dataLocale !== locale) && !failed) this.loadData()
    }

    componentDidUpdate(prevProps) {
        const { level } = this.props

        if (prevProps.level !== level) this.loadData()
    }

    loadData = () => {
        const { module, block, id, level, tenderId, loadPublishersData } = this.props

        loadPublishersData(module, block, id, level, tenderId)
    }

    render() {
        const { data, id, intl, tenderId, isLoading } = this.props

        if (isLoading) {
            return (
                <div className={'won-tenders-sub-table-publishers-wrapper'}>
                    <div className={'table-title'}>{intl.formatMessage({ id: `${LOCALE_PREFIX}.publishers` })}</div>
                    <div className={'no-list-table-data'}>{intl.formatMessage({ id: `global.loading` })}</div>
                </div>
            )
        }

        return (
            <div className={'won-tenders-sub-table-publishers-wrapper'}>
                <div className={'table-title'}>{intl.formatMessage({ id: `${LOCALE_PREFIX}.publishers` })}</div>
                {_.isEmpty(data) && (
                    <div className={'no-list-table-data'}>
                        {intl.formatMessage({ id: `${LOCALE_PREFIX}.noPublishers` })}
                    </div>
                )}
                <ListTable
                    id={`won-tenders-sub-table-publishers-table-${id}-${tenderId}`}
                    itemIdentifier={'subject.id'}
                    staticData={{
                        _table: [
                            {
                                key: `won-tenders-sub-table-publishers-table-${id}-${tenderId}`,
                                tables: [
                                    {
                                        rows: data,
                                    },
                                ],
                            },
                        ],
                    }}
                    texts={{
                        controlExpand: intl.formatMessage({ id: 'global.controlExpand' }),
                        controlMore: intl.formatMessage({ id: 'global.controlMore' }),
                        controlLess: intl.formatMessage({ id: 'global.controlLess' }),
                        controlAll: intl.formatMessage({ id: 'global.controlAll' }),
                        controlClose: intl.formatMessage({ id: 'global.controlClose' }),
                        controlFirst: intl.formatMessage({ id: 'global.controlFirst' }),
                    }}
                    columnsDefinition={{
                        title: {
                            Cell: () => (
                                <CellStyleWrapper isCentered>
                                    <span>{intl.formatMessage({ id: `${LOCALE_PREFIX}.publisher` })}</span>
                                </CellStyleWrapper>
                            ),
                            width: 100,
                        },
                        top: {
                            columns: [
                                {
                                    accessor: 'subject',
                                    Cell: ({ value, original }) => (
                                        <CellStyleWrapper isCentered>
                                            <Entity
                                                entity={value}
                                                value={value?.name}
                                                type={value?.type}
                                                inactive={value?.inactive}
                                                entId={value?.id}
                                                rowInactive={original?.inactive}
                                            />
                                        </CellStyleWrapper>
                                    ),
                                },
                                {
                                    accessor: 'subject.indicators',
                                    Cell: ({ value, original }) => (
                                        <CellStyleWrapper isCentered>
                                            <Signals
                                                id={original?.subject?.id}
                                                notice={value?.notice}
                                                risk={value?.risk}
                                                caution={value?.caution}
                                            />
                                        </CellStyleWrapper>
                                    ),
                                    width: 150,
                                },
                            ],
                        },
                    }}
                />
            </div>
        )
    }
}
